import { render, staticRenderFns } from "./Subfolders.vue?vue&type=template&id=1cbb078f&scoped=true"
import script from "./Subfolders.vue?vue&type=script&lang=js"
export * from "./Subfolders.vue?vue&type=script&lang=js"
import style0 from "./Subfolders.vue?vue&type=style&index=0&id=1cbb078f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb078f",
  null
  
)

export default component.exports